import { State } from "./types";
/*
 * define state here
 */
const loader = (): State => ({
  isLoading: false
});

export default loader;
